<div class="color-picker-wrapper" *ngIf="isColorPickerDisplay">
  <div class="color-picker"
    [ngClass]="!color ? 'select-color' : ''"
    [style.background]="backgroundColor"
    [(colorPicker)]="color"
    [cpOutputFormat]="'hex'"
    [cpPosition]="cpPosition"
    [cpSaveClickOutside]="true"
    [ngStyle]="{ 'background-color': getRGBAColorFromHex() }"
    [cpAlphaChannel]="'always'"
    [cpPresetColors]="presetColors"
    (colorPickerClose)="onChange($event)"
    cpAlphaChannel="hex8">
    <span class="text-color" [ngStyle]="{ 'color': textColor }">
      {{ !color ? ('system.selectColor' | translate) : color  }}
    </span>
  </div>

  <mat-icon (click)="onResetColor()" matTooltip="Clear">close</mat-icon>
</div>

